module.exports = __webpack_public_path__ + "img/highSpeedRail-1.daf55564.jpg";